/**
 * BoardGame class
 * 
 * Represents a BoardGameGeek board game with its basic info.
 */
class BoardGame {
    constructor(id, name, href, image, thumbnail) {
        this.id = id;
        this.name = name;
        this.href = href;
        this.image = image;
        this.thumbnail = thumbnail;
    }

    /**
     * Create a BoardGame from API response data
     * @param {Object} data - Raw API data
     * @returns {BoardGame}
     */
    static fromApiResponse(data) {
        // Image can come from data.image, data.thumbnail, or data.linkedimage.image.src
        let imageUrl = data.image || data.thumbnail;
        if (!imageUrl && data.linkedImage && data.linkedImage.image && data.linkedImage.image.src) {
            imageUrl = data.linkedImage.image.src;
        }
        
        return new BoardGame(
            data.item.id || data.item.objectid,
            data.item.name,
            data.item.href,
            imageUrl,
            data.item.thumbnail
        );
    }

    /**
     * Get the full BGG URL for this game
     * @returns {string}
     */
    getBggUrl() {
        return `https://boardgamegeek.com/boardgame/${this.id}`;
    }
}

export default BoardGame;